import { createBrowserRouter, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import Layout from '../components/common/Layout';

// Auth pages
import LandingPage from '../features/auth/pages/LandingPage';
import LoginPage from '../features/auth/pages/LoginPage';
import SignUpPage from '../features/auth/pages/SignUpPage';
import AuthSuccessPage from '../features/auth/pages/AuthSuccessPage';
import AuthErrorPage from '../features/auth/pages/AuthErrorPage';

// Athlete pages
import AthleteDashboardPage from '../features/analytics/pages/AthleteDashboardPage';
import ActivitiesListPage from '../features/activities/pages/ActivitiesListPage';
import ActivityDetailPage from '../features/activities/pages/ActivityDetailPage';
import AnalyticsHubPage from '../features/analytics/pages/AnalyticsHubPage';
import WorkoutAnalyticsPage from '../features/analytics/pages/WorkoutAnalyticsPage';
import CourseAnalyticsPage from '../features/analytics/pages/CourseAnalyticsPage';
import WorkoutCalendarPage from '../features/workouts/pages/WorkoutCalendarPage';
import WorkoutDetailPage from '../features/workouts/pages/WorkoutDetailPage';
import MyTrainersPage from '../features/shared/pages/MyTrainersPage';


// Trainer pages
// import TrainerDashboardPage from '../features/trainer/pages/TrainerDashboardPage';
import AthletesListPage from '../features/trainer/pages/AthletesListPage';
import AthleteProfilePage from '../features/trainer/pages/AthleteProfilePage';
import WorkoutTemplatesPage from '../features/trainer/pages/WorkoutTemplatesPage';
import CreateTemplatePage from '../features/trainer/pages/CreateTemplatePage';
import UpdateTemplatePage from '../features/trainer/pages/UpdateTemplatePage';
import AssignWorkoutPage from '../features/trainer/pages/AssignWorkoutPage';

// Admin pages
import AdminDashboardPage from '../features/admin/pages/AdminDashboardPage';
import UsersManagementPage from '../features/admin/pages/UsersManagementPage';
import SystemHealthPage from '../features/admin/pages/SystemHealthPage';
import ShardsManagementPage from '../features/admin/pages/ShardsManagementPage';
import FeatureFlagsPage from '../features/admin/pages/FeatureFlagsPage';

// Shared pages
import UserSettingsPage from '../features/shared/pages/UserSettingsPage';
import NotificationsCenterPage from '../features/shared/pages/NotificationsCenterPage';

/**
 * React Router configuration with role-based routing
 * Defines all application routes with authentication guards and role-based access control
 */
const router = createBrowserRouter([
  // Public routes
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignUpPage />,
  },
  {
    path: '/auth/success',
    element: <AuthSuccessPage />,
  },
  {
    path: '/auth/error',
    element: <AuthErrorPage />,
  },

  // Athlete routes
  {
    path: '/athlete',
    element: (
      <ProtectedRoute requiredRoles={['athlete', 'both']}>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/athlete/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <AthleteDashboardPage />,
      },
      {
        path: 'activities',
        element: <ActivitiesListPage />,
      },
      {
        path: 'activities/:activityId',
        element: <ActivityDetailPage />,
      },
      {
        path: 'analytics',
        element: <AnalyticsHubPage />,
      },
      {
        path: 'analytics/workouts',
        element: <WorkoutAnalyticsPage />,
      },
      {
        path: 'courses/:courseId/analytics',
        element: <CourseAnalyticsPage />,
      },
      {
        path: 'workouts',
        element: <WorkoutCalendarPage />,
      },
      {
        path: 'workouts/:workoutId',
        element: <WorkoutDetailPage />,
      },
      {
        path: 'trainers',
        element: <MyTrainersPage />,
      },

    ],
  },

  // Trainer routes
  {
    path: '/trainer',
    element: (
      <ProtectedRoute requiredRoles={['trainer', 'both']}>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/trainer/dashboard" replace />,
      },
      // {
      //   path: 'dashboard',
      //   element: <TrainerDashboardPage />,
      // },
      {
        path: 'athletes',
        element: <AthletesListPage />,
      },
      {
        path: 'athletes/:athleteId',
        element: <AthleteProfilePage />,
      },
      {
        path: 'templates',
        element: <WorkoutTemplatesPage />,
      },
      {
        path: 'templates/create',
        element: <CreateTemplatePage />,
      },
      {
        path: 'templates/edit/:templateId',
        element: <UpdateTemplatePage />,
      },
      {
        path: 'assign',
        element: <AssignWorkoutPage />,
      },
    ],
  },

  // Admin routes
  {
    path: '/admin',
    element: (
      <ProtectedRoute requiredRoles={['superuser']}>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/admin/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <AdminDashboardPage />,
      },
      {
        path: 'users',
        element: <UsersManagementPage />,
      },
      {
        path: 'health',
        element: <SystemHealthPage />,
      },
      {
        path: 'shards',
        element: <ShardsManagementPage />,
      },
      {
        path: 'flags',
        element: <FeatureFlagsPage />,
      },
    ],
  },

  // Shared authenticated routes
  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <UserSettingsPage />,
      },
    ],
  },
  {
    path: '/notifications',
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <NotificationsCenterPage />,
      },
    ],
  },

  // Catch-all redirect
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
],
  {
    basename: '/Surge',
  });

export default router;